// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1aJ_-","label":"styles_label__3if5d"};